define(['app', 'nouislider', 'cropper'], function (app, slider) {
  return app.Marionette.ItemView.extend({
    template: false,

    templateHelpers: function () {
      return {}
    },

    options: {
      width: 150,
      heigth: 150,
      margin: 12,
      type: 'circle',
      customWrapper: '',
      cropping: false,
      labels: {}
    },

    ui: {
      zoomContainer: '.cropper-zoom',
      zoom: '.cropper-zoom .js-slider',
      image: '.cropper-container img',
      cropbox: '.cropper-container'
    },

    getData: function () {
      return this.getOption('cropping')
    },

    getSizeCropper: function (side) {
      side = side === 'width' ? side : 'height'
      return parseInt(this.options[side])
    },

    onCropZoomChanged: function (value) {
      value = Math.floor(value) / 100
      if (this.cropper) this.cropper.zoom(value)
    },

    onCropChange: function (e, data, cropper) {
      this.cropper = cropper
      this.options.cropping = data
    },

    onDisableCropper: function () {
      var html = this.ui.cropbox.html()
      this.cropper.remove()
      this.ui.zoomContainer.addClass('is-transparant')
      this.ui.cropbox.html(html)
    },

    onDisableZoom: function () {
      this.ui.zoomContainer.addClass('is-transparant')
    },

    getZoomLimits: function () {
      var maxWidth = this.getOption('width')
      var maxHeight = this.getOption('height')
      var width = this.image.width
      var height = this.image.height
      var minZoom = 100
      var start = false

      if (maxWidth >= maxHeight && width >= height) {
        if (height >= maxHeight + this.getOption('margin')) {
          start = (maxHeight + this.getOption('margin') * 2) * 100 / height
        }
        minZoom = maxHeight * 100 / height
      } else {
        if (width >= maxWidth + this.getOption('margin')) {
          start = (maxWidth + this.getOption('margin') * 2) * 100 / width
        }
        minZoom = maxWidth * 100 / width
      }

      start = start ? Math.round(start) : false

      if (!isFinite(start)) {
        start = false
      }

      if (!isFinite(minZoom)) {
        minZoom = 10
      }

      return {
        start: start,
        min: Math.round(minZoom)
      }
    },

    setCropper: function () {
      // Initialize the cropper ~ once.
      var self = this
      var cropper = this.ui.image

      self.cropper = false

      self.image = {
        width: cropper[0].width,
        height: cropper[0].height
      }

      var zoomLimits = this.getZoomLimits()

      app
        .$(cropper[0])
        .cropbox({
          width: self.getSizeCropper('width'),
          height: self.getSizeCropper('height'),
          showControls: 'never',
          controls: false,
          zoom: zoomLimits.start || zoomLimits.min,
          maxZoom: 1
        })
        .on('cropbox', function (e, data, cropper) {
          if (cropper) {
            self.cropper = cropper
            self.setZoomSlider(zoomLimits)
          }
          self.onCropChange.apply(self, arguments)
        })
    },

    setZoomSlider: function (zoomLimits) {
      if (zoomLimits.min === 100) {
        return this.ui.zoomContainer.toggleClass('is-transparant', true)
      }

      this.ui.zoomContainer.toggleClass('is-transparant', false)

      var self = this
      var minZoom = zoomLimits.min || 10

      if (!this.slider) {
        this.slider = true
        slider.create(this.ui.zoom[0], {
          start: zoomLimits.start || minZoom,
          connect: 'lower',
          behaviour: 'tap',
          range: {
            min: minZoom,
            max: 100
          }
        })

        this.ui.zoom[0].noUiSlider.on('update', function (value) {
          // onCropZoomChanged
          self.triggerMethod('crop:zoom:changed', value[0])
        })

        self.triggerMethod('crop:zoom:changed', zoomLimits.start || minZoom)
      }
    },

    onRender: function () {
      this.setCropper()
    }
  })
})
